import api from "../api";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FactCounter from "./Utilities/FactCounter";
import { useEffect, useState, useRef } from "react";
import DynamicCampus from "./DynamicSections/DynamicCampus";
import DynamicEvents from "./DynamicSections/DynamicEvents";
import DynamicFaqSection from "./DynamicSections/DynamicFaqSection";
import HappeningsAtChettinad from "./Carousel/HappeningsAtChettinad";
import DynamicImgCarousel from "./DynamicSections/DynamicImgCarousel";
import DynamicAlumniStudents from "./DynamicSections/DynamicAlumniStudents";
import DynamicContentSections from "./DynamicSections/DynamicContentSections";
import DynamicHomeTestimonial from "./DynamicSections/DynamicHomeTestimonial";
import DynamicFromOurStudents from "./DynamicSections/DynamicFromOurStudents";
import DynamicHighlightsSection from "./DynamicSections/DynamicHighlightsSection";
import DynamicDepartmentsSection from "./DynamicSections/DynamicDepartmentsSection";

const Home = ({ hasTopMenu }) => {
  const [bannerData, setBannerData] = useState({
    media: null,
    alt_text: "",
    title: "",
    title_color: "#fff",
    buttons: [],
    social_icons: [],
    admission_button: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const sliderRef = useRef(null);

  // --- State for Dynamic Updates ---
  const [updates, setUpdates] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const dropdownRef = useRef(null);
  const modalRef = useRef(null);

  // --- State for Dynamic Popup ---
  const [popupData, setPopupData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (document.getElementById("npf-chatbot-script")) {
      const icon = document.getElementById("__eechatIcon");

      if (icon) {
        icon.style.display = "block";

        icon.setAttribute("role", "button");
        icon.setAttribute("tabindex", "0");
        icon.setAttribute(
          "aria-label",
          "Open admission assistant chatbot"
        );

        icon.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            icon.click();
          }
        });
      }

      return;
    }

    const chatbotDiv = document.createElement("div");
    chatbotDiv.className = "npf_chatbots";
    chatbotDiv.setAttribute(
      "data-w",
      "9e39fc039db54ac3811a0569ae36cee7"
    );
    chatbotDiv.style.display = "none";

    document.body.appendChild(chatbotDiv);

    const script = document.createElement("script");

    script.id = "npf-chatbot-script";
    script.async = true;

    script.src =
      "https://chatbot.in8.nopaperforms.com/en-gb/backend/bots/niaachtbtscpt.js/567763e385fe3ebc7/9e39fc039db54ac3811a0569ae36cee7";

    script.onload = () => {
      setTimeout(() => {
        const icon = document.getElementById("__eechatIcon");

        if (icon) {
          icon.setAttribute("role", "button");

          icon.setAttribute("tabindex", "0");

          icon.setAttribute(
            "aria-label",
            "Open admission assistant chatbot"
          );

          icon.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              icon.click();
            }
          });
        }
      }, 1500);
    };

    document.body.appendChild(script);

    return () => {
      const icon = document.getElementById("__eechatIcon");

      if (icon) {
        icon.style.display = "none";
      }
    };
  }, []);

  useEffect(() => {
    const fetchPopup = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/api/sitepages/academic/popup`);
        if (response.data.status && response.data.data.status === 1) {
          setPopupData(response.data.data);
          setShowPopup(true);
        }
      } catch (err) {
        console.error("Failed to fetch popup:", err);
      }
    };
    fetchPopup();
  }, []);

  useEffect(() => {
    const fetchUpdates = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/api/sitepages/academic/latest-updates`);

        if (response.data.status) {
          const sortedData = response.data.data.sort((a, b) => a.order - b.order);

          const formattedUpdates = sortedData.map((item) => {
            let finalLink = item.file_url;
            if ((item.type === 'pdf' || item.type === 'image') && !item.file_url.startsWith('http')) {
              finalLink = `${process.env.REACT_APP_API_URL}/public${item.file_url}`;
            }

            return {
              text: item.name,
              link: finalLink,
              type: item.type,
            };
          });

          setUpdates(formattedUpdates);
        }
      } catch (err) {
        console.error("Failed to fetch updates:", err);
      }
    };

    fetchUpdates();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showDropdown &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }

      if (
        showModal &&
        modalRef.current &&
        !modalRef.current.contains(event.target)
      ) {
        setShowModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showDropdown, showModal]);

  // --- Fetch Banner Data ---
  useEffect(() => {
    const fetchBannerData = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/api/main-banner`);
        const data = response.data;

        setBannerData({
          media: data.media,
          alt_text: data.alt_text || "",
          title: data.title || "",
          title_color: data.title_color || "#fff",
          buttons: data.buttons?.map((button) => ({
            text: button.text,
            link: button.link,
            target: button.target || "_self"
          })) || [],
          social_icons: data.social_icons || [],
          admission_button: data.admission_button || []
        });
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchBannerData();
  }, []);

  if (loading) return <></>;
  if (error) return <></>;

  const settings = {
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    cssEase: "linear",
    adaptiveHeight: true,
    beforeChange: (current, next) => {
      if (sliderRef.current) {
        sliderRef.current.slickPlay();
      }
    },
  };

  const handleMouseEnter = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPlay();
    }
  };

  const handleMouseLeave = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPlay();
    }
  };

  return (
    <>
      <style>
        {`

           #__eechatIcon {
      z-index: 999 !important;
    }
    .indicator{
      z-index: 999 !important;
    }
    
          .sticky-icon a:hover {
            color: #0d6efd !important; 
          }
          .sticky-icon.social-media a:hover {
            color: white !important; 
          }

          /* Popup Styles */
          .home-popup-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.8);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 99999;
            padding: 20px;
          }
          .home-popup-content {
            position: relative;
            max-width: 600px;
            width: 100%;
            background: white;
            border-radius: 8px;
            overflow: visible;
            box-shadow: 0 5px 15px rgba(0,0,0,0.3);
          }
          .home-popup-close {
            position: absolute;
            top: -15px;
            right: -15px;
            font-size: 28px;
            color: #fff;
            background: var(--thm-bg);
            border: none;
            width: 33px;
            height: 33px;
            line-height: 30px;
            border-radius: 50%;
            cursor: pointer;
            z-index: 10;
          }
            .home-popup-close:hover {
            position: absolute;
            top: -15px;
            right: -15px;
            font-size: 28px;
            color: #fff;
            background: var(--thm-bg-2);
            border: none;
            width: 33px;
            height: 33px;
            line-height: 30px;
            border-radius: 50%;
            cursor: pointer;
            z-index: 10;
          }
          .home-popup-content img {
            width: 100%;
            display: block;
            height: auto;
          }
        `}
      </style>

      {/* --- Dynamic Popup Section --- */}
      {showPopup && popupData && (
        <div
          className="home-popup-overlay"
          onClick={() => setShowPopup(false)}   // ✅ Outside click closes
        >
          <div
            className="home-popup-content"
            onClick={(e) => e.stopPropagation()} // ❌ Prevent inside close
          >
            {/* Close Icon */}
            <button
              className="home-popup-close"
              onClick={() => setShowPopup(false)} // ✅ Close icon closes
            >
              &times;
            </button>

            {/* Image */}
            <Link to={popupData.link} onClick={() => setShowPopup(false)}>
              <picture>
                <source
                  media="(max-width: 767px)"
                  srcSet={`${process.env.REACT_APP_API_URL}/public${popupData.media.mobile_image}`}
                />
                <img
                  src={`${process.env.REACT_APP_API_URL}/public${popupData.media.desktop_image}`}
                  alt="Special Announcement"
                />
              </picture>
            </Link>
          </div>
        </div>
      )}


      {bannerData.social_icons && (
        <div className="sticky-icon social-media">
          {bannerData.social_icons.instagram?.active === '1' && (
            <a href={bannerData.social_icons.instagram.link} target="_blank" rel="noopener noreferrer" className="Instagram">
              Instagram <i className="fa fa-instagram"></i>
            </a>
          )}
          {bannerData.social_icons.facebook?.active === '1' && (
            <a href={bannerData.social_icons.facebook.link} target="_blank" rel="noopener noreferrer" className="Facebook">
              Facebook <i className="fa fa-facebook-f"></i>
            </a>
          )}
          {bannerData.social_icons.whatsapp?.active === '1' && (
            <a href={bannerData.social_icons.whatsapp.link} target="_blank" rel="noopener noreferrer" className="Google">
              WhatsApp <i className="fa fa-whatsapp"></i>
            </a>
          )}
          {bannerData.social_icons.youtube?.active === '1' && (
            <a href={bannerData.social_icons.youtube.link} target="_blank" rel="noopener noreferrer" className="Youtube">
              YouTube <i className="fa fa-youtube-play text-danger"></i>
            </a>
          )}
          {bannerData.social_icons.twitter?.active === '1' && (
            <a href={bannerData.social_icons.twitter.link} target="_blank" rel="noopener noreferrer" className="Twitter">
              Twitter
              <svg viewBox="0 0 24 24" fill="currentColor" style={{ marginLeft: "4px", background: "white", height: "30px", width: "30px", color: "rgb(46 164 255 / 80%)", borderRadius: "50%", marginRight: "6px", transition: "all 0.5s" }}>
                <path d="M18.244 2H21.5l-7.12 8.146L22.75 22h-6.67l-5.23-6.88L4.89 22H1.63l7.62-8.71L1.25 2h6.82l4.73 6.23L18.24 2z" transform="translate(12 12) scale(0.55 0.55) translate(-12 -12)" />
              </svg>
            </a>
          )}

          <div className="notification-icon">
            <button className="awesome-button new-ribbon-btn" onClick={() => setShowDropdown(prev => !prev)}>NEW</button>
            {showDropdown && (
              <div ref={dropdownRef} className="notification-dropdown show">
                <div className="dropdown-header">Latest Updates <span className="close-btn" onClick={() => setShowDropdown(false)}>×</span></div>
                <ul className="notification-list">
                  {updates.length > 0 ? (
                    updates.slice(0, 5).map((u, i) => (
                      <li key={i}>
                        <span className="new-badge">NEW</span>
                        {(u.type === 'pdf' || u.type === 'image') ? (
                          <a href={u.link} target="_blank" rel="noopener noreferrer">
                            {u.text.length > 50 ? `${u.text.substring(0, 50)}...` : u.text}
                          </a>
                        ) : (
                          <Link to={u.link}>
                            {u.text.length > 50 ? `${u.text.substring(0, 50)}...` : u.text}
                          </Link>
                        )}
                      </li>
                    ))
                  ) : (
                    <li style={{ textAlign: "center", padding: "10px", color: "#666" }}>No new updates</li>
                  )}
                </ul>
                {updates.length > 0 && (
                  <div className="dropdown-footer">
                    <a href="#" className="view-more-notify" onClick={(e) => { e.preventDefault(); setShowDropdown(false); setShowModal(true); }}>View All Updates →</a>
                  </div>
                )}
              </div>
            )}

            {showModal && (
              <div className="full-modal">
                <div className="modal-content" ref={modalRef}>
                  <span className="close-modal" onClick={() => setShowModal(false)}>&times;</span>
                  <h2 className="mb-3">All Latest Updates</h2>
                  <ul className="modal-notification-list">
                    {updates.length > 0 ? (
                      updates.map((u, i) => (
                        <li key={i}>
                          <span className="new-badge">NEW</span>
                          {(u.type === 'pdf' || u.type === 'image') ? (
                            <a href={u.link} target="_blank" rel="noopener noreferrer" onMouseEnter={(e) => (e.target.style.color = "#0d6efd")} onMouseLeave={(e) => (e.target.style.color = "")}>{u.text}</a>
                          ) : (
                            <Link to={u.link} onMouseEnter={(e) => (e.target.style.color = "#0d6efd")} onMouseLeave={(e) => (e.target.style.color = "")}>{u.text}</Link>
                          )}
                        </li>
                      ))
                    ) : (
                      <li style={{ textAlign: "center", listStyle: "none", color: "#666" }}>No new updates available.</li>
                    )}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {bannerData.admission_button && bannerData.admission_button.active === '1' && (
        <div className="vertical-tab">
          <a href={bannerData.admission_button.link} alt="Apply Now">
            <button className="apply-now">
              <div><div><div className="vertical-text">{bannerData.admission_button.text || "Apply Now"}</div></div></div>
            </button>
          </a>
        </div>
      )}

      <div className="boxed_wrapper ltr">
        {bannerData.media && (
          <section className={`main-slider style1 nav-style2 ${!hasTopMenu ? "mt-0" : ""}`}>
            <div className="slider-box">
              <div className="banner-carousel active">
                {Array.isArray(bannerData.media) ? (
                  <Slider {...settings} ref={sliderRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    {bannerData.media.map((img, index) => (
                      <div className="slide" key={index}>
                        <img className="hide-mobile" src={`${process.env.REACT_APP_API_URL}/public${img}`} alt={bannerData.alt_text || `Slide ${index + 1}`} />
                        <div className="overlay-content-video"></div>
                        <div className="auto-container">
                          <div className="content middle text-center">
                            {bannerData.title && (
                              <div className="big-title">
                                <h2 style={{ color: bannerData.title_color }}>{bannerData.title}</h2>
                              </div>
                            )}
                           <div className="btns-box mt-5">
  {bannerData.buttons.map((button, i) => (
    <a
      key={i}
      className="btn-one-home"
      href={button.link}
    >
      <span className="txt">{button.text}</span>
    </a>
  ))}
</div>

                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                ) : (
                  <div className="slide">
                    {bannerData.media.match(/\.(mp4|mov|avi|mkv)$/i) ? (
                      <>
                        <video className="video hide-mobile" autoPlay muted loop playsInline>
                          <source src={bannerData.media} type="video/mp4" />
                        </video>
                        <div className="overlay-content-video"></div>
                      </>
                    ) : (
                      <>
                        <img className="hide-mobile" src={bannerData.media} alt={bannerData.alt_text ?? 'home_image'} />
                        <div className="overlay-content-video"></div>
                      </>
                    )}
                    <div className="auto-container">
                      <div className="content middle text-center">
                        {bannerData.title && (
                          <div className="big-title">
                            <h2 style={{ color: bannerData.title_color }}>{bannerData.title}</h2>
                          </div>
                        )}
                      <div className="btns-box mt-5">
  {bannerData.buttons.map((button, i) => (
    <a
      key={i}
      className="btn-one-home"
      href={button.link}
    >
      <span className="txt">{button.text}</span>
    </a>
  ))}
</div>

                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </section>
        )}

        <DynamicCampus />
        <DynamicContentSections />
        <section className="high-school-study-educamb-area mt-0 mt-md-5 homepage">
          <div className="high-school-study-educamb-area-bg" style={{ backgroundImage: "url(https://generalcwdbucket.s3.us-east-1.amazonaws.com/assets/images/resources/high-school-study-educamb-area-bg.jpg)" }}></div>
          <div className="container">
            <div className="sec-title text-center pt-0">
              <h2>Awards & Accreditations</h2>
              <div className="sub-title">
                <p>Offering the best university experience and providing students with exceptional education from an accredited institution.</p>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-12"><DynamicImgCarousel groupId={1} /></div>
            </div>
          </div>
        </section>
        <DynamicDepartmentsSection />
        <DynamicHighlightsSection />
        <HappeningsAtChettinad />
        <FactCounter />
        <DynamicAlumniStudents />
        <DynamicEvents />
        <DynamicHomeTestimonial />
        <DynamicFromOurStudents />
        <DynamicFaqSection page="home" />
      </div>
    </>
  );
};

export default Home;